import React from 'react';
import Styles from "../../assets/css/common/pagination.module.scss";

const Pagination = (props) => {
  const { currentPage, totalPage, showing } = props.data;

  // Function to determine the pages to display
  const getPageData = () => {
    const pageData = [];
    let decrementPage = 0;

    // Add previous pages
    for (let index = currentPage; index > 0; index--) {
      if (decrementPage < 3) {
        pageData.push(index);
      }
      decrementPage++;
    }

    let incrementPage = 0;

    // Add next pages
    for (let index = currentPage + 1; index <= totalPage; index++) {
      if (incrementPage < 2) {
        pageData.push(index);
      }
      incrementPage++;
    }

    return pageData.sort((a, b) => a - b);
  };

  const pageData = getPageData();
  const hasPrev = currentPage > 1;
  const hasNext = currentPage < totalPage;

  return (
    <div className={`${Styles.paginationWrapper}`}>
      <div className={`${Styles.showing}`}>
        Showing
        <select value={showing} onChange={(e) => props.pageClick(e.target.value, "show")}>
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="15">15</option>
        </select>
      </div>
      <div className={`${Styles.pagination}`}>
        <button
          className={`${!hasPrev ? Styles.disabled : ''} ${currentPage === 1 ? Styles.prevActive : ''}`}
          onClick={() => props.pageClick(currentPage - 1, "page")}
          disabled={!hasPrev}
        >
          PREV
        </button>
        {
          pageData.map((data) => (
            <button
              key={data}
              className={`${currentPage === data ? Styles.active : ''}`}
              onClick={() => props.pageClick(data, "page")}
            >
              {data}
            </button>
          ))
        }
        <button
          className={`${!hasNext ? Styles.disabled : ''} ${currentPage === totalPage ? Styles.nextActive : ''}`}
          onClick={() => props.pageClick(currentPage + 1, "page")}
          disabled={!hasNext}
        >
          NEXT
        </button>
      </div>
    </div>
  );
};

export default Pagination;
